import Request from './request'

const Device_Group = {
  updateGroup (params, callback, bad_answer) {
    Request.post('device-group/update', JSON.stringify(params)).then(callback).catch(bad_answer)
  },
  getGroupList (callback) {
    Request.get('device-group/index').then(callback).catch(this.bad_answer)
  },
  addDeviceGroup (params, callback) {
    Request.post('device-group/add', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  deleteDeviceGroup (params, callback, bad_answer) {
    Request.post('device-group/delete', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getListDevicesByIdGroup (params, callback) {
    Request.post('device-group/devices-by-id', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceGroupConfig (group_id, callback) {
    Request.get('device-group/config/' + group_id).then(callback).catch(this.bad_answer)
  },
  saveDeviceGroupConfig (params, callback) {
    Request.post('device-group/save-config', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  
}
export default Device_Group
